import { Box, Collapse, Typography, useTheme } from "@mui/material";
import Iconify from "./iconify";
import Chip from "./Chip";
import { useLocales } from "src/locales";

export default function CollapsibleChipSelect({
    listKey,
    title,
    open,
    setOpen,
    options,
    selectedOptions,
    setValue,
    updateArray
}) {
    const theme = useTheme();
    const { translate } = useLocales();

    const translateTag = (name) => {
        return translate(`bookingTags.${name.replace(/[ \-\/]/g, "")}`)
    }

    return (
        <>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    cursor: "pointer"
                }}
                onClick={() => { setOpen(prev => !prev) }}
            >
                <Box display="flex" alignItems="center" sx={{ mt: 2.7, mb: 0.9 }} gap={1}>
                    <Iconify
                        icon="eva:chevron-down-fill"
                        width={32}
                        sx={{
                            display: "inline-flex",
                            transition: (t) =>
                                t.transitions.create("transform", {
                                    duration: 300,
                                    easing: t.transitions.easing.easeInOut,
                                }),
                            transform: open ? "rotate(0deg)" : "rotate(-90deg)",
                            willChange: "transform",
                        }}
                        aria-hidden
                    />
                    <Typography variant="subtitle1" sx={{ fontFamily: "Visby" }}>{title}</Typography>
                </Box>
            </Box>
            <Collapse
                in={open}
                timeout={300}
                collapsedSize={0}
                unmountOnExit={false}
            >

                <Box sx={{
                    marginLeft: 3.5,
                    display: "flex",
                    flexDirection: "row",
                    overflowX: "visible",
                    overflowY: "hidden",
                    flexWrap: "nowrap",
                    px: 1,
                }}>
                    {options
                        .map(({ id, name }, index) => {
                            const isSelected = selectedOptions.find((o) => o === id);
                            return (
                                <Chip
                                    color="default"
                                    id={id}
                                    label={translateTag(name)}
                                    sx={{
                                        marginRight: 1,
                                        mb: 1,
                                        fontSize: theme.typography.h6.fontSize,
                                        padding: "11px 10px",
                                        lineHeight: "26px",
                                        height: "48px",
                                        backgroundColor: isSelected ? theme.palette.common.white : undefined,
                                        color: isSelected
                                            ? theme.palette.background.default
                                            : theme.palette.text.primary,
                                        '&:hover': {
                                            backgroundColor: isSelected ? theme.palette.common.white : undefined,
                                        },
                                    }}
                                    key={index}
                                    onClick={() => {
                                        setValue(
                                            listKey,
                                            updateArray(listKey, id)
                                        );
                                    }}
                                />
                            )
                        })}
                </Box>
            </Collapse>

        </>
    )
}